import React from "react";
import { useNavigate } from "react-router-dom";
import { linkOpen } from "utils/util";
import CmsPreviewShell from "./CmsPreviewShell";

const InstructorComponent = ({ title, subtitle, layout, items = [] }) => {
  const navigate = useNavigate();
  const handleClick = (link) => linkOpen(link, navigate);

  return (
    <CmsPreviewShell title={title} subtitle={subtitle}>
      <div className={`cms-instructor cms-instructor--${layout}`}>
        {items.map((item) => (
          <div key={item.id} className="cms-instructor__item" onClick={() => handleClick(item.link)}>
            <div className="cms-instructor__avatar">
              <img src={item.img} alt={item.title} />
            </div>
            <div className="cms-instructor__body">
              <div className="cms-instructor__head">
                <h5 className="cms-instructor__name">{item.title}</h5>
                {item.brand_name && (
                  <span className="cms-instructor__brand">{item.brand_name}</span>
                )}
              </div>
              <p className="cms-instructor__desc">{item.description}</p>
              <div className="cms-instructor__chips">
                {item.sports.map((s) => (
                  <span key={s} className="cms-instructor__chip cms-instructor__chip--sport">
                    {s}
                  </span>
                ))}
                {item.certificates.slice(0, 2).map((c) => (
                  <span key={c} className="cms-instructor__chip cms-instructor__chip--cert">
                    {c}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </CmsPreviewShell>
  );
};

export default InstructorComponent;
